import { render } from "./TerminalCategory.vue?vue&type=template&id=732e236c&ts=true"
import script from "./TerminalCategory.vue?vue&type=script&lang=ts"
export * from "./TerminalCategory.vue?vue&type=script&lang=ts"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__